import React, { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import DAProtect from '@wix/da-ds/pkg/Icons/24x24/DAProtect';
import s from './DaProtectNotice.scss';
const DaProtectNotice = ()=>{
    const { t  } = useTranslation();
    const onClick = useCallback((e)=>{
        window.location.assign('https://www.deviantartsupport.com/en/article/what-is-deviantart-protect');
        e.preventDefault();
    }, []);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("div", {
        className: s['da-protect-heading']
    }, /*#__PURE__*/ React.createElement(DAProtect, {
        className: s['da-protect-icon']
    }), t('daProtect.submit.heading')), /*#__PURE__*/ React.createElement("div", {
        className: s['da-protect-content']
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "daProtect.submit.content"
    }, "DeviantArt has your back...", /*#__PURE__*/ React.createElement("br", null), "Now all new submissions enjoy 3 months protection against art theft on DeviantArt.", /*#__PURE__*/ React.createElement("span", {
        className: s['fake-link'],
        onClick: onClick
    }, "Learn more"))));
};
DaProtectNotice.displayName = 'DaProtectNotice';
export default DaProtectNotice;
